export const LAST_SEARCHES_SERVICE = "LastSearchesService";

export type Filters = {
  makes?: Array<Array<{ name: string }>>;
  vehicleType?: string;
};

export type ParsedLastSearch = {
  brand?: string;
  model?: string;
  vehicleType?: "car" | "bike";
  location?: string;
  route: string;
  query: string;
  fullUrl: string;
};
